import { Type } from '@sinclair/typebox';

import type { XYZ, XYZW } from './3d';
// Annotation Image Upload types
export interface AnnotationImageUploadParams {
  itemId: string;
  annotationId: string;
  filename: string;
}

export interface AnnotationImageUploadResponse {
  path: string;
  url: string;
}

// TypeBox schema for API validation
export const AnnotationImageUploadParamsSchema = Type.Object({
  itemId: Type.String({ format: 'uuid' }),
  annotationId: Type.String({ format: 'uuid' }),
});

export const AnnotationImageUploadQuerySchema = Type.Object({
  filename: Type.String(),
});

export const AnnotationImageUploadResponseSchema = Type.Object({
  path: Type.String(),
  url: Type.String(),
});

// Annotation data types
export interface AnnotationData {
  id: string;
  position: XYZ;
  rotation?: XYZW;
  name: string;
  description?: string;
  image_path?: string | File; // Use image_path to match database schema
  image_url?: string; // Dynamic field resolved from image_path
  camera_view_id?: string;
  temp_camera_view_id?: string; // For temporary linking during editing (UI state only)
}

export interface CameraViewData {
  id: string;
  name?: string;
  order: number;
  target: XYZ;
  position: XYZ;
  rotation: XYZW;
  annotation_id?: string;
}

// Constants
export const ANNOTATION_IMAGE_MAX_SIZE = 2 * 1024 * 1024; // 2MB
export const ANNOTATION_IMAGE_ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
];
